"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateHelper_1 = require("../helper/DateHelper");
var Appointment = /** @class */ (function () {
    function Appointment(props) {
        this.startDate = props.startDate;
        this.endDate = props.endDate;
        this.grade = props.grade;
    }
    /**
     * Build the display info (localized) based on the current iappointment data
     * @param lang lang for the display
     * @returns Appoint info that can be shower to end user
     */
    Appointment.prototype.getDisplayInfo = function (lang, timeZone) {
        if (timeZone === void 0) { timeZone = 'Europe/Paris'; }
        var end = new Date(this.endDate);
        var lang_ = lang !== null && lang !== void 0 ? lang : 'fr';
        var endHour = (0, DateHelper_1.convertTZHours)(this.endDate, timeZone);
        return {
            fullYear: end.toLocaleDateString(lang_, {
                year: 'numeric',
                timeZone: timeZone
            }),
            day: end.toLocaleDateString(lang_, {
                day: 'numeric',
                timeZone: timeZone
            }),
            weekday: capitalizeFirstLetter(end.toLocaleDateString(lang_, {
                weekday: 'long',
                timeZone: timeZone
            })),
            month: end.toLocaleDateString(lang_, {
                month: 'long',
                timeZone: timeZone
            }),
            displayedStartTime: endHour <= 12 ? '8H' : '13H30',
            displayedEndTime: endHour <= 12 ? '12H' : '17H'
        };
    };
    return Appointment;
}());
/**
 * Capitalizes the first letter of a string
 * @param string String to capitalize
 * @returns The capitalized string
 */
function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
exports.default = Appointment;
